import { jsx as p } from "react/jsx-runtime";
import { c as a } from "./index-65016bfa.mjs";
import S, { css as k } from "styled-components";
import "@fcamna/shared-component-foundations";
import "react";
import { u as c } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
const u = S.div`
  &.Skeleton {
    ${({
  theme: {
    components: { skeleton: e }
  }
}) => k(e.Skeleton)};
  }
`, j = ({
  variant: e = "text",
  height: t,
  width: o,
  animation: n = !0,
  children: m,
  textType: r = "headline",
  className: s,
  size: l
}) => {
  const i = c({ label: "Skeleton" });
  return /* @__PURE__ */ p(
    u,
    {
      style: {
        width: o ? `${o}px` : void 0,
        height: t ? `${t}px` : void 0
      },
      className: a([
        "Skeleton",
        `Skeleton--${r}`,
        `Skeleton--${e}`,
        `Skeleton--${l}`,
        { "Skeleton--animation": n },
        s
      ]),
      ...i,
      children: m
    }
  );
};
export {
  j as Skeleton
};
